export const escapeCsvValue = (
  value: string | number | null | undefined,
): string => {
  const stringValue =
    value === null || value === undefined ? '' : String(value);
  if (/[",\n]/.test(stringValue)) {
    return `"${stringValue.replace(/"/g, '""')}"`;
  }
  return stringValue;
};

export const buildCsvContent = (
  headers: string[],
  rows: (string | number | null | undefined)[][],
): string =>
  [headers, ...rows]
    .map((row) => row.map(escapeCsvValue).join(','))
    .join('\r\n');
